<!-- <a class="offer-button" href="https://spirical-maps.firebaseapp.com//company/u/XcaWLkXt9N1Q45WBg8AA/WrJLJ1cKksmPZua/calculatorh" target="_blank"></a> -->

<ul class="right-menu" *ngIf="!removeAllMenu" [class.active]="showMenu" [class.remove-menu]="removeAllMenu"
    role="navigation" aria-label="Main">
    <li class="proj-menu-holder">
        <a aria-label="עמוד פרויקט" (click)='goToProject()' onmouseenter="player.play()" onmouseleave="player.stop()"
            href='javascript:;' class="menu-item title-button home-show home-menu">
            <span *ngIf="this.hoisUrl !== 'https://habaitproject.co.il'">{{ 'PROJ-HOME-PAGE' | translate }}</span>
            <span *ngIf="this.hoisUrl === 'https://habaitproject.co.il'">הבית</span>

            <!-- <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 21.98"><path d="M15,21.98H3c-.8,0-1.55-.31-2.12-.88-.57-.57-.88-1.32-.88-2.12V7.98c0-.62,.15-1.24,.42-1.79,.28-.55,.68-1.04,1.18-1.41L7.2,.58c1.03-.77,2.57-.77,3.6,0l5.6,4.2c.5,.37,.9,.86,1.18,1.41,.28,.55,.42,1.17,.42,1.79v11c0,.8-.31,1.55-.88,2.12s-1.32,.88-2.12,.88ZM9,1.98c-.21,0-.43,.07-.6,.2L2.8,6.38c-.25,.19-.45,.43-.59,.71-.14,.28-.21,.59-.21,.89v11c0,.27,.1,.52,.29,.71,.19,.19,.44,.29,.71,.29H15c.26,0,.52-.11,.71-.29s.29-.44,.29-.71V7.98c0-.31-.07-.62-.21-.89-.14-.28-.34-.52-.59-.71h0S9.6,2.18,9.6,2.18c-.17-.13-.39-.2-.6-.2Zm1,16h-2v-6h2v6Z"/></svg> -->
            <!-- <lottie-player class="home-lottie" id="player" src="https://lottie.host/3bff823e-6013-497c-8376-b24518264709/ykCKgaOICk.json" background="transparent" speed="1" loop autoplay ></lottie-player> -->
            <lottie-player id="player" class="lottie"
                src="https://lottie.host/3f13dfc4-be11-4bd0-8875-e66381fd67ab/6iGDwvYvwp.json" background="transparent"
                speed="1" loop autoplay></lottie-player>
        </a>
    </li>
    <li *ngIf="this.modulesArray[0] && modulesArray[0].buildingsTitle" class="buildings-menu-holder">
        <a aria-label="פותח תפריט תת תפריט של בחירת בניין" (click)='openBuildings("buildMenu")'
            (focus)='openBuildingsFocus("buildMenu")' href='javascript:;' onmouseenter="buildingLottie.play()"
            onmouseleave="buildingLottie.stop()" class="menu-item title-button building-show buildings-menu"
            [class.active]='this.showBuildingSubMenu'>
            <span *ngIf="this.currentLanguage === 'he'">{{ modulesArray[0].buildingsTitle }}</span>
            <span *ngIf="this.currentLanguage === 'en'">buildings{{ modulesArray[0].buildingsTitleEn}}</span>
            <lottie-player id="buildingLottie" class="lottie"
                src="https://lottie.host/3dd91191-750a-4762-8f80-fffa1d34c160/RHnfBKNyCe.json" background="transparent"
                speed="1" loop autoplay></lottie-player>
        </a>
        <app-building-list @slideUpMenu *ngIf="showBuildingSubMenu"
            (showBuildingSubMenu)='openBuildings("buildMenuSub")' [projId]="this.projId"
            [routeParams]="this.routeParams">
        </app-building-list>
    </li>
    <li *ngIf="this.modulesArray[0] && modulesArray[0].floorsTitle" class="floor-menu-holder">
        <a aria-label="פותח תפריט תת תפריט של בחירת קומה" (click)='openBuildings("floorMenu")'
            (focus)='openBuildingsFocus("floorMenu")' href='javascript:;' onmouseenter="floorLottie.play()"
            onmouseleave="floorLottie.stop()" class="menu-item title-button floors-show floors-menu"
            [class.active]='this.showFloorsViewSubMenu'>
            <span *ngIf="this.currentLanguage === 'he'">{{ modulesArray[0].floorsTitle}}</span>
            <span *ngIf="this.currentLanguage === 'en'">floors{{ modulesArray[0].floorsTitleEn}}</span>
            <lottie-player id="floorLottie" class="lottie"
                src="https://lottie.host/776622e7-4dd7-402c-9a64-df3240a3c2b8/20E8j3hr8M.json" background="transparent"
                speed="1" loop autoplay></lottie-player>

        </a>
        <app-views-from-floors-list @slideUpMenu (showBuildingSubMenu)='openBuildings("floorMenuSub")'
            *ngIf="showFloorsViewSubMenu" [projId]="this.projId" [routeParams]="this.routeParams">
        </app-views-from-floors-list>
    </li>
    <li class="gallery-holder-item" [class.dropdown]="compositeDesign" class="gal-menu-holder">
        <a aria-label="פותח תפריט תת תפריט של בחירת גלריות" (click)='showSubGalleryF($event)'
            (focus)='showSubGalleryFocus($event)' [class.active]='this.showSubGallery' href='javascript:;'
            onmouseenter="galleryLottie.play()" onmouseleave="galleryLottie.stop()"
            class="menu-item title-button simulation-show galleries-menu"
            [class.dropdown-title]="compositeDesign"><span>{{ 'GALLERY' | translate }}</span>
            <lottie-player id="galleryLottie" class="lottie"
                src="https://lottie.host/2c3ba93c-99fc-42db-844d-c3a6866c10d0/gKnraCUNeJ.json" background="transparent"
                speed="1" loop autoplay></lottie-player>
            <!-- <ng-lottie containerClass="lottie" [options]="options"></ng-lottie> -->
        </a>
        <div @slideUpMenu class="row sub-menu menu-build gallery-sub-menu" [class.active]='this.showSubGallery'
            *ngIf='this.showSubGallery'>
            <a _ngcontent-hir-c279="" href="javscript:;" class="close-section ng-tns-c279-12 ng-star-inserted"
                (click)="this.showSubGallery = false"></a>
            <ul class="sub-menu-content">
                <!-- <li *ngIf="modulesArray[0].simulatorsTitle">
                    <a (click)="openSimple('progImages')" href='javascript:;'
                        class="menu-item title-button simulation-show"
                        [ngClass]="{'active': this.galleryType == 'progImages'}">
                        <span>{{ modulesArray[0].simulatorsTitle }}</span></a>
                </li>
                <li *ngIf="modulesArray[0].simpleTitle">
                    <a (click)='openSimple("simpleImage")' href='javascript:;'
                        class="menu-item title-button construction-show"
                        [ngClass]="{'active': this.galleryType == 'simpleImage'}"><span>{{
                            modulesArray[0].simpleTitle }}</span></a>
                </li>
                <li *ngIf="modulesArray[0].simple1Title">
                    <a (click)='openSimple("simpleImage1")' href='javascript:;'
                        class="menu-item title-button construction-show"
                        [ngClass]="{'active': this.galleryType == 'simpleImage1'}"><span>{{
                            modulesArray[0].simple1Title }}</span></a>
                </li>
                <li *ngIf="modulesArray[0].simple2Title">
                    <a (click)='openSimple("simpleImage2")' href='javascript:;'
                        class="menu-item title-button construction-show"
                        [ngClass]="{'active': this.galleryType == 'simpleImage2'}"><span>{{
                            modulesArray[0].simple2Title }}</span></a>
                </li>
                <li *ngIf="modulesArray[0].videoTitle">
                    <a (click)='openSimple("progVideo")' href='javascript:;'
                        class="menu-item title-button video-show"
                        [ngClass]="{'active': this.galleryType == 'progVideo'}"><span>{{
                            modulesArray[0].videoTitle }}</span></a>
                </li>
                <li *ngIf="modulesArray[0].pdfTitle">
                    <a (click)='openSimple("progPDF")' href='javascript:;'
                        class="menu-item title-button pdf-show"
                        [ngClass]="{'active': this.galleryType == 'progPDF'}"><span>{{
                            modulesArray[0].pdfTitle }}</span></a>
                </li>
                <li *ngIf="modulesArray[0].simple3Title">
                    <a (click)='openSimple("simpleImage3")' href='javascript:;'
                        class="menu-item title-button construction-show"
                        [ngClass]="{'active': this.galleryType == 'simpleImage3'}"><span>{{
                            modulesArray[0].simple3Title }}</span></a>
                </li> -->
                <!-- <li *ngIf="modulesArray[0].simple3Title">
                    <a (click)='openSimple("simpleImage3")' href='javascript:;'
                        class="menu-item title-button construction-show"
                        [ngClass]="{'active': this.galleryType == 'simpleImage3'}"><span>{{
                            modulesArray[0].simple3Title }}</span></a>
                </li> -->
                <li class="gallery-holder-item">
                    <div *ngIf="projUid" class="dynamic-gallery-in-menu">
                        <app-n-menu-page-with-link (closeSubMenu)="closeSubMenu($event)" [galleryIdInput]="galleryIdInput" [outOfGalleryMenu]="false"
                            [parentId]=projUid class="menu-view-page-with-link"></app-n-menu-page-with-link>
                    </div>
                </li>
            </ul>
        </div>
    </li>
    <li *ngIf="desktopResolution" class="out-of-menu-item-holder">
        <div *ngIf="projUid" class="dynamic-gallery-in-menu out-of-gallery">
            <app-n-menu-page-with-link (closeSubMenu)="closeSubMenu($event)" [galleryIdInput]="galleryIdInput" [outOfGalleryMenu]="true"
                [parentId]=projUid class="menu-view-page-with-link"></app-n-menu-page-with-link>
        </div>
    </li>
    <li *ngIf="desktopResolution" class="map-menu-holder">
        <a aria-label="עמוד מפה של הפרויקט כרגע לא לחיץ" href="javascript:;"
            (click)='openBuildings("showMapViewSubMenu")' class="map-menu" onmouseenter="mapLottie.play()"
            onmouseleave="mapLottie.stop()"><span>{{ 'MAP' | translate }}</span>
            <lottie-player id="mapLottie" class="lottie"
                src="https://lottie.host/aad234fe-4f50-42ce-b670-31080ce153e8/r231bs9IUr.json" background="transparent"
                speed="1" loop autoplay></lottie-player>

        </a>
        <app-nearby-places-list *ngIf="showMapViewSubMenu && !hideMapSubMenu" @slideUpMenu
            [routeParams]="this.routeParams" (showMapViewSubMenu)="openBuildings('showMapViewSubMenu')"
            class="sub-menu"
            [enableCustomMarkers]="enableCustomMarkers"
            [additionalCategories]="additionalCategories"></app-nearby-places-list>
    </li>
    <li *ngIf="desktopResolution && !hideAboutMenu" class="info-menu-holder">
        <a href="javascript:;" class="about-menu" (click)='aboutProject()' onmouseenter="aboutLottie.play()"
            onmouseleave="aboutLottie.stop()"><span>{{ 'ABOUT-PROJECT' | translate }}</span>
            <lottie-player id="aboutLottie" class="lottie"
                src="https://lottie.host/0cd3b4c7-2c35-48c6-8346-24feef39352b/wNsu9IQ88b.json" background="transparent"
                speed="1" loop autoplay></lottie-player>

        </a>
    </li>

    <li class="sub-right-menu-holder sub-menu">
        <a aria-label="עמוד על הפרויקט כרגע לא לחיץ" class="sub-right-menu" href="javascript:;"
            (click)="openBuildings('sub')"><span></span></a>
        <ul @slideUpMenu *ngIf="subRightmenuShow" class="sub-menu-content">
            <a *ngIf="!showMapViewSubMenu" href="javscript:;" class="close-section ng-tns-c279-12 ng-star-inserted"
                (click)="this.subRightmenuShow = false"></a>
            <li>
                <!-- <a href="javascript:;">
                    <div class="text map-menu">
                      
                    </div>
                    <div  class="title"> על הפרויקט</div>
                </a> -->
                <a aria-label="עמוד מפה של הפרויקט" href="javascript:;" (click)='openBuildings("showMapViewSubMenu")'>
                    <div class="text map-menu">

                    </div>
                    <div class="title">{{ 'MAP' | translate }}</div>
                    <lottie-player id="mapLottie" class="lottie"
                        src="https://lottie.host/aad234fe-4f50-42ce-b670-31080ce153e8/r231bs9IUr.json"
                        background="transparent" speed="1" loop autoplay></lottie-player>

                </a>
                <app-nearby-places-list *ngIf="showMapViewSubMenu && !hideMapSubMenu"
                    (showMapViewSubMenu)='showMapViewSubMenuF("showMapViewSubMenu")' @slideUpMenu
                    [routeParams]="this.routeParams"
                    [enableCustomMarkers]="enableCustomMarkers"
                    [additionalCategories]="additionalCategories"></app-nearby-places-list>
            </li>
            <li *ngIf="!hideAboutMenu">
                <a href="javascript:;" (click)='openBuildings("showAboutProject")'>
                    <div class="text about-menu"></div>
                    <div class="title">{{ 'ABOUT-PROJECT' | translate }}</div>
                </a>
            </li>
        </ul>
    </li>
</ul>
<div *ngIf="this.hoisUrl !== 'https://habaitproject.co.il'" class="powered-by" aria-label="generated by spirikal">
    generated by: <a href="https://spirikal.co.il/"> spirikal
    </a></div>
<div *ngIf="this.hoisUrl === 'https://habaitproject.co.il'" class="powered-by" aria-label="generated by spirikal"><a
        href="https://habait.biz/"> Habait
    </a></div>